import { styled } from '../../../stitches.config';

export const TextField = styled('input', {
  'padding': '$3 $4',
  'borderRadius': '$small',
  'border': '1px solid $gray5',
  'height': '$55',
  'fontSize': '$1',
  '&:hover': {
    borderColor: '$gray8',
  },
  '&:focus-visible': {
    outline: 'none',
    borderColor: '$gray10',
  },
  '&::placeholder': {
    color: '$gray11',
    fontStyle: 'italic',
  },
  'variants': {
    large: {
      true: {
        padding: '$2 $3',
        fontSize: '$3',
      },
    },
    minimal: {
      true: {
        backgroundColor: 'transparent',
        border: 'none',
      },
    },
    active: {
      true: {
        backgroundColor: '$gray6',
      },
    },
    intent: {
      none: {
        backgroundColor: 'white',
      },
      primary: {
        backgroundColor: '&gray8',
      },
    },
    fullWidth: {
      true: {
        width: '100%',
      },
    },
    isError: {
      true: {
        borderColor: '$red6',
        color: '$red11',
        backgroundColor: '$red1',
      },
    },
  },
  'defaultVariants': {
    intent: 'none',
  },
});
